import axios from 'axios'
import { UserExistsResponse } from '@babylon/consumer-api/types'
import { getHashedEmail } from '@/utils'

const appUrl = window.initialState?.config.app.appUrl

const baseURL = `${appUrl}/api/v2/auth0`

/**
 * We call directely Core Ruby because a IP rate limit is set
 */
const checkExistingUser = (email: string) =>
  axios.post<UserExistsResponse>(`${baseURL}/user_exists`, {
    email_hash: getHashedEmail(email),
  })

export default checkExistingUser
